
  export function calculateUniquenessRatio(totalSpawned: number, uniqueSpawned: number): number {
    if (totalSpawned === 0) {
        return 0;
    }
    return totalSpawned / uniqueSpawned;
  }

  export function calcualteMaxAgentPercentage(initiationPoints: number, totalSpawned: number): number {
    if (totalSpawned === 0) {
        return 0;
    }

    return totalSpawned / initiationPoints;
  }


  export function calculateComplexity(startingNumber: number,totalSpawned: number,uniqueSpawned: number): number {
    const duplicationFactor:number = calculateDuplicationFactor(totalSpawned, uniqueSpawned);
    const growthFactor:number = calculateGrowthFactor(totalSpawned, startingNumber);
    const uniqueGrowthFactor:number = calculateUniqueGrowthFactor(uniqueSpawned, startingNumber);

    // Store the results in an object

    return duplicationFactor * growthFactor / uniqueGrowthFactor;
}


export function calculateDuplicationFactor(totalSpawned: number, uniqueSpawned: number): number {
  if (uniqueSpawned === 0) {
      throw new Error("Unique spawned numbers cannot be zero.");
  }
  return totalSpawned / uniqueSpawned;
}

export function calculateGrowthFactor(totalSpawned: number, startingNumber: number): number {
  if (startingNumber === 0) {
      throw new Error("Starting number cannot be zero.");
  }
  return totalSpawned / startingNumber;
}

export function calculateUniqueGrowthFactor(uniqueSpawned: number, startingNumber: number): number {
  if (startingNumber === 0) {
      throw new Error("Starting number cannot be zero.");
  }
  return uniqueSpawned / startingNumber;
}
